<template>
  <div id="publications">
    <menu-default/>
      <div class="jumbotron jumbotron-fluid">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h1 class="title text-center"><i class="fa fa-file-o"></i> Comprar Publicações</h1>
            </div>
          </div>
        </div>
      </div>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="input-group" style="margin-bottom: 10px">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa fa-search"></i></span>
            </div>
            <input type="text" class="form-control" id="myInput" @keyup.enter="getPublications(1)" v-model="search" placeholder="Filtrar publicações..." />
            <div class="input-group-append">
              <span class="input-group-text" @click="getPublications(1)"><i class="fa fa-refresh"></i></span>
            </div>
          </div>
          <table v-show="!loading" class="table table-bordered table-bordered" style="background: white">

            <thead class="thead-dark">
            <tr>
              <th scope="col">Publicação</th>
              <th class="text-center" scope="col" width="50">Revisão</th>
              <th class="text-center" scope="col" width="100">Atualização</th>
              <th class="text-center" scope="col" width="100">Valor</th>
              <th scope="col" width="200"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(publication,i) in publications" :key="publication">
              <td>
                <small style="font-size: 0.7em" class="pull-right" v-if="publication.is_signature"> / Assinatura de um ano</small>
                <small style="font-size: 0.7em" class="pull-right" v-else> / Compra única</small>

                <small style="font-size: 0.7em" class="pull-right" v-if="publication.is_download">Download  &nbsp;</small>
                <small style="font-size: 0.7em" class="pull-right" v-else>Impresso &nbsp;</small>
                {{ publication.name }}<br />
                <small>
                  {{ publication.applicability }}
                  <br/>
<!--                  assinatura: {{ publication.is_signature }},-->
<!--                  download: {{ publication.is_download }},-->
<!--                  imagem: {{ publication.has_photo_upload }},-->
<!--                  airplane: {{ publication.has_airplane_info }}-->
                </small>
              </td>
              <td class="text-center"><small>v.{{ publication.version }}</small></td>
              <td class="text-center"><small>{{ publication.date | formatDate }}</small></td>
              <td class="text-center"><small>R$ {{ publication.price | formatPrice }} </small></td>
              <td>
                <div v-if="publication.active">
                  <button class="pull-right btn btn-add-to-cart" :class="publication.active ? 'active':''" @click="removeProductToCart(publication,i)">Remover do carrinho</button><br/>
                </div>
                <div v-else>
                  <button class="pull-right btn btn-add-to-cart" :class="publication.active ? 'active':''" @click="addProductToCart(publication,i)">Adicionar ao carrinho</button><br/>
                </div>
                <a class="pull-right btn btn-buy" @click="goToCart()">Finalizar compra</a><br/>
              </td>
            </tr>
            <tr v-show="!publications.length"><td colspan="5" class="text-center">Nenhum resultado pode ser encontrado</td></tr>
            </tbody>
          </table>
          <div class="pagination pagination-medium pagination-right"  v-if="publications.length > 0">
            <div class="pull-left">
              Pagina {{current}} de {{pages}}
            </div>
            <ul>
              <li id="previous"><a href="javascript:;" @click="getPublications(previous)">Anterior</a></li>
              <li id="next"><a href="javascript:;" @click="getPublications(next)">Próxima</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>


    <footer-default/>
  </div>
</template>

<script>
  import publication from "../api/publication"
  import menuDefault from "./common/menu-default";
  import footerDefault from "./common/footer-default";
  import mixins from "../helpers/mixins"
  import { mapState } from 'vuex'
  export default {
    name: "Publications",
    mixins: [mixins],
    data () {
      return {
        publications: [],
        loading: true
      }
    },
    components: { menuDefault, footerDefault },
    methods: {
      addProductToCart(product,i){
        this.$store.dispatch('addProductToCart', product)
        this.publications[i]['active'] = true
      },
      removeProductToCart(product,i){
        for(let cart_key in this.cart){
          if(this.cart[cart_key]['id'] === this.publications[i]['id']){
            this.$store.commit('deleteFromCart', cart_key)
            this.publications[i]['active'] = false
          }
        }
      },
      goToCart(){
        this.$router.push({name: 'cart'})
      },
      getPublications(page){
        publication.list(page, this.search).then((response)  =>  {
          let publications = response.data.results
          this.treatPagination(page, response.data.count, response.data.pages)
          let cart = this.cart
          publications.forEach(function(publication){
            publication.active = false
            cart.forEach(function(cartItem){
              if(publication.id == cartItem.id || publication.active){
                publication.active = true
              }
            })
          })

          this.publications = publications
          this.loading = false
        })
      }
    },
    activated(){
      this.getPublications(1)
    },
    mounted(){
      this.getPublications(1)
    },
    computed: {
      ...mapState({
        'logged': state => state.logged,
        'cart': function(){ return this.$store.getters.getCart  }
      })
    },
  }
</script>

<style scoped>
  #myInput {
      font-size: 18px; /* Increase font-size */
  }
</style>
